<script>
import {getText,getTextJson} from "@/utils/text";

export default {
  data() {
    return {
      showMenu: false,
      languageList: [
        {
          value: 'en',
          name: 'English'
        },{
          value: 'ru',
          name: 'Русский'
        }
      ]
    }
  },
  created() {
    getTextJson()
  },
  mounted() {
    let that = this
    that.$store.state.isPhone = document.body.clientWidth <= 768;
    window.onresize = () => {
      return (() => {
        that.$store.state.isPhone = document.body.clientWidth <= 768;
      })()
    };
  },
  methods: {
    getViewText(key) {
      return getText(key)
    },
    getTextJson
  }
}
</script>

<template>
  <div>
    <section class="header text-size-2 sm:header-sm md:header-md lg:header-lg sm-md:header-sm-md">
      <div class="md:max-w-[720px] lg:max-w-[960px] xl:max-w-[1140px] mx-auto h-full">
        <div class="flex justify-between h-full">
          <div class="hidden lg:flex items-center">

            <div class="hidden lg:flex items-center">
              <router-link :to="{ name: 'index' }">
                <img src="../assets/img/logo.png" alt="Rummy" title="Rummy" width="100" loading="lazy">
              </router-link>
            </div>

            <div class="line">
              <img src="../assets/img/line1.png">
            </div>

            <nav class="hidden lg:block">
              <el-menu class="el-menu-demo" mode="horizontal">
                <el-submenu>
                  <template slot="title">{{ getViewText('rummy') }}</template>
                  <el-menu-item>
                    <router-link :to="{ name: 'gameIntroduction' }">{{ getViewText('rummy') }}</router-link>
                  </el-menu-item>

                  <el-menu-item>
                    <a class="flex items-center p-0 menubutton" target=""
                       href="https://www.davisandgrill.com/apk/DavisandGrillRummy.apk">
                      <div class="text">{{ getViewText('rummy_app') }}</div>
                    </a>
                  </el-menu-item>
                </el-submenu>
              </el-menu>
            </nav>

            <nav class="hidden lg:block">
              <el-menu class="el-menu-demo" mode="horizontal">
                <el-submenu>
                  <template slot="title">{{ getViewText('legal') }}</template>
                  <el-menu-item>
                    <router-link :to="{ name: 'termsconditions' }">T & C</router-link>
                  </el-menu-item>
                  <el-menu-item>
                    <router-link :to="{ name: 'privacypolicy' }">{{ getViewText('privacy_policy')}}</router-link>
                  </el-menu-item>
                  <el-menu-item>
                    <router-link :to="{ name: 'refundpolicy' }">{{ getViewText('refund_policy')}}</router-link>
                  </el-menu-item>
                </el-submenu>
              </el-menu>
            </nav>

            <nav class="hidden lg:block">
              <el-menu class="el-menu-demo" mode="horizontal">
                <el-submenu>
                  <template slot="title">{{ getViewText('company') }}</template>
                  <el-menu-item>
                    <router-link :to="{ name: 'aboutus' }">{{ getViewText('about_us') }}</router-link>
                  </el-menu-item>
                  <el-menu-item>
                    <router-link :to="{ name: 'contactus' }">{{ getViewText('contact_us') }}</router-link>
                  </el-menu-item>
                </el-submenu>
              </el-menu>
            </nav>

          </div>

          <div
            class="flex justify-between app-signup-download app-signup-download-sm md:app-signup-download-md lg:app-signup-download-lg">
            <div>
              <span style="opacity: 0.5">{{ getViewText('select_language')}}</span>
              <el-select v-model="$store.state.language" size="mini" @change="getTextJson" style="width: 100px;">
                <el-option v-for="item in languageList" :key="item.key" :label="item.name" :value="item.value"/>
              </el-select>
            </div>

            <div class="menu flex lg:hidden" id="nav_list">

              <button type="button" @click="showMenu=!showMenu"><img alt="menu" title="Online Rummy" loading="lazy"
                                                                     width="16" height="14" decoding="async"
                                                                     data-nimg="1" class="menu_img"
                                                                     style="color:transparent"
                                                                     src="../assets/img/hamburger-menu-white.svg">
              </button>
              <a class="d-block" href="https://www.davisandgrill.com/"><img alt="A23" title="A23" loading="lazy"
                                                                            width="36"
                                                                            height="26" decoding="async" data-nimg="1"
                                                                            class="logo" style="color:transparent"
                                                                            src="../assets/img/logo.png"></a>
            </div>
            <div class="download-links-icons items-center hidden lg:flex"><a
              href="https://www.davisandgrill.com/apk/DavisandGrillRummy.apk"><img alt="download a23 app for android"
                                                                                   loading="lazy" width="24" height="24"
                                                                                   decoding="async" data-nimg="1"
                                                                                   style="color:transparent"
                                                                                   src="../assets/img/android-solid-white.svg"></a>
            </div>
            <!-- <div class="download-links-icons items-center hidden lg:flex">
              <a href="https://www.a23.com/rummy/download-rummy.html">
                <img alt="download a23 app for android"
                          loading="lazy" width="24" height="24"
                          decoding="async" data-nimg="1"
                          style="color:transparent"
                          src="../assets/img/android-solid-white.svg">
              </a>
            </div> -->
          </div>
        </div>
      </div>
    </section>

    <!-- 侧边栏，手机上可以显示，或者 -->
    <div id="leftMenu" class="lg:hidden leftmenu sm:leftmenu-sm md:leftmenu-md sm-md:leftmenu-sm-md" v-if="showMenu">
      <nav class="relative navigations">
        <div class="menu-content">
          <ul>
            <li class="close-login-part lg:hidden flex items-center justify-between">
              <span class="fs-18">
                <a href="https://www.a23.com/">
                  <img src="../assets/img/logo.png" alt="A23 Rummy" height="24" width="33.23" id="mobileMenuLogo"
                       class="logo" loading="lazy">
                </a>
              </span>
              <button type="button" @click="showMenu=false">
                <img src="../assets/img/times-white.svg" alt="Close" title="Rummy App" height="14" width="14"
                     class="menu-close">
              </button>
            </li>
            <li class="menu-item py-3">
              <router-link :to="{ name: 'gameIntroduction' }">{{ getViewText('rummy') }}</router-link>
            </li>
            <li class="menu-item py-3">
              <a class="flex items-center p-0 menubutton" target="_blank" href="#">
                <div>{{ getViewText('rummy_app') }}</div>
              </a>
            </li>
            <li class="menu-item py-3">
              <router-link :to="{ name: 'termsconditions' }">T & C</router-link>
            </li>
            <li class="menu-item py-3">
              <router-link :to="{ name: 'privacypolicy' }">{{ getViewText('privacy_policy') }}</router-link>
            </li>
            <li class="menu-item py-3">
              <router-link :to="{ name: 'refundpolicy' }">{{ getViewText('refund_policy') }}</router-link>
            </li>
            <li class="menu-item py-3">
              <router-link :to="{ name: 'aboutus' }">{{ getViewText('about_us') }}</router-link>
            </li>
            <li class="menu-item py-3">
              <router-link :to="{ name: 'contactus' }">{{ getViewText('contact_us') }}</router-link>
            </li>
          </ul>
        </div>
        <div class="absolute download-btn">
          <button type="button" id="A23GamesApp"
                  class="gtm_a23games_main_btn_btm btn-download-a23 flex justify-center items-center text-size-4">
            <img src="../assets/img/download_icon.png" alt="A23 Rummy" class="donwload-icon" width="24" height="24">
            <a href="https://www.davisandgrill.com/apk/DavisandGrillRummy.apk">{{ getViewText('download_now') }}</a>
          </button>
        </div>
      </nav>
    </div>
  </div>
</template>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/head.vue